// Customer
export const Customer = 'customerData'
export const CustomerHref = 'customerHref'
export const CustomerToken = 'customerToken'

// Cart
export const CartStorage = 'storage-cart'

// OrderDetails
export const CheckoutRestore = 'checkout-restore'
export const OrderDetailsShipping = 'orderdetails-shipping-method'
export const OrderDetailsDelivery = 'orderdetails-delivery-restore'
export const OrderDetailsPickUp = 'orderdetails-pickup-restore'
export const OrderDetailsMotorDelivery = 'orderdetails-motordelivery-restore'